import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink
  ],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss'
})
export class NavigationComponent {
  constructor(private router: Router, private apiService: ApiService) {
    
  }

  current : string = 'dashboard';
  current2 : string = '';

  courses: any;

  ngOnInit() {
    this.setCurrentRoute(this.router.url);
    this.getCourses();
  
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.setCurrentRoute(event.urlAfterRedirects);
      });
  }

  getCourses () {
    let self = this;
    
    return this.apiService.get('/office/courses').then(function (response: any) {
      self.courses = response['data'];
    }).catch(function (e) {
    });
  }
  
  private setCurrentRoute(url: string) {
    url = url.replace(/^\//, '');
    const pieces = url.split('/');
    url = pieces[0];
    let url2 = !pieces[1] ? '' : pieces[1];
  
    this.current = url;
    this.current2 = url2;
  }
}
